// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Link-cls1___199c7ed58610ac0f824{/*!*/}.Link-cls2__ed5c95ed59e778671e1a{word-break:break-all;color:#0c3b8d}.Link-cls2__ed5c95ed59e778671e1a:hover,.Link-cls2__ed5c95ed59e778671e1a:focus{text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Link-cls1___199c7ed58610ac0f824",
	"cls2": "Link-cls2__ed5c95ed59e778671e1a Link-cls1___199c7ed58610ac0f824"
};
export default ___CSS_LOADER_EXPORT___;
